import { type ReactNode, Suspense } from 'react';

import { PageLoader } from '@/app/router/page-loader';

export function withSuspense(element: ReactNode, fallback?: ReactNode) {
  return (
    <Suspense fallback={fallback ?? <PageLoader />}>{element}</Suspense>
  );
}
